import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {UnitTypeToTextPipe} from "../../../pipes/unit-type-to-text.pipe";
import {SeniorUnitAdvertisementDto} from "homey-housing-lottery-app-dto";
import {FilterByUnitTypePipe} from "../../../pipes/filter-by-unit-type.pipe";
import {unitTypes} from "../../../model/unit-type";

@Component({
  selector: 'homey-senior-eligible-units',
  standalone: true,
  imports: [
    UnitTypeToTextPipe,
    FilterByUnitTypePipe
  ],
  templateUrl: './senior-eligible-units.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SeniorEligibleUnitsComponent {
  public readonly eligibleUnits = input.required<SeniorUnitAdvertisementDto[]>();
  protected readonly unitTypes = unitTypes;
}
